module.exports = __webpack_public_path__ + "assets/img/quickStart-bg-vip.6e4091f4.png";